exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".i-copyright {\n  flex: 0 0 auto;\n}\n", "", {"version":3,"sources":["D:/Project/Mooho/FrontEnd/mooho-base-admin/src/components/copyright/D:/Project/Mooho/FrontEnd/mooho-base-admin/src/components/copyright/index.vue?vue&type=style&index=0&id=1688f062&prod&lang=less&","D:/Project/Mooho/FrontEnd/mooho-base-admin/src/components/copyright/index.vue"],"names":[],"mappings":"AACA;EACE,eAAA;CCAF","file":"index.vue?vue&type=style&index=0&id=1688f062&prod&lang=less&","sourcesContent":["\n.i-copyright {\n  flex: 0 0 auto;\n}\n",".i-copyright {\n  flex: 0 0 auto;\n}\n"],"sourceRoot":""}]);

// exports
